module.exports = __webpack_public_path__ + "images/quotas/projects_upsell_light.svg";